import {
  getDirectusField
} from "directus/src/operations";

export async function fetchBillableStatuses() {
  try {
    const response = await getDirectusField("billables", "status");
    const data = response.meta.options.choices.map((status) => {
      return { name: status.text, id: status.value };
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}